import { Subject } from 'rxjs';
export class ChatInstance {
  constructor() {
    this.currentMsgId = 0;
    this.sentMessages = [];
    this.onChatStart$ = new Subject();
    this.onChatEnd$ = new Subject();
    this.onStatusChange$ = new Subject();
    this.onTransferRequest$ = new Subject();
    this.onParticipantJoin$ = new Subject();
    this.onParticipantLeave$ = new Subject();
    this.onIsTyping$ = new Subject();
    this.onNewMessage$ = new Subject();
    this.onMessageAcknowledgement$ = new Subject();
    this.onError$ = new Subject();
    this.onProviderTransfer$ = new Subject();
    this.transferInProgress = false;
  }
  observableEvents() {
    return {
      onChatStart$: this.onChatStart$.asObservable(),
      onChatEnd$: this.onChatEnd$.asObservable(),
      onStatusChange$: this.onStatusChange$.asObservable(),
      onTransferRequest$: this.onTransferRequest$.asObservable(),
      onParticipantJoin$: this.onParticipantJoin$.asObservable(),
      onParticipantLeave$: this.onParticipantLeave$.asObservable(),
      onIsTyping$: this.onIsTyping$.asObservable(),
      onNewMessage$: this.onNewMessage$.asObservable(),
      onMessageAcknowledgement$: this.onMessageAcknowledgement$.asObservable(),
      onError$: this.onError$.asObservable(),
    };
  }
  emitError(code, message, endChat = false, error) {
    this.onError$.next({
      code,
      message,
      endChat,
      error,
    });
  }
  emitStatusChange(provider, connectionStatus) {
    this.currentState = connectionStatus;
    this.onStatusChange$.next({
      provider,
      connectionStatus,
      timestamp: new Date(),
    });
  }
  emitParticipantJoin(provider, participant) {
    this.onParticipantJoin$.next({
      participant,
      provider,
      timestamp: new Date(),
    });
  }
  emitIsTyping(participant) {
    this.onIsTyping$.next({
      participant,
      isTyping: true,
      timestamp: new Date(),
    });
  }
  emitMessageAcknowledge(id, status) {
    this.onMessageAcknowledgement$.next({ id: id.toString(), status });
    this.sentMessages[id].ackInfo = status;
  }
  emitNewMessage(provider, participant, messages) {
    const timestamp = new Date();
    this.onNewMessage$.next({
      messages,
      provider,
      participant,
      timestamp,
    });
  }
  emitParticipantLeave(provider, participant) {
    this.onParticipantLeave$.next({
      participant,
      provider,
      timestamp: new Date(),
    });
  }
  emitTransferRequestInternal(transferTo) {
    this.onTransferRequest$.next({
      type: 'INTERNAL',
      transferTo,
      timestamp: new Date(),
    });
  }
  emitTransferRequestProvider(transferData) {
    this.transferInProgress = true;
    this.onTransferRequest$.next({
      type: 'PROVIDER',
      transferTo: transferData.transferToProviderId,
      timestamp: new Date(),
    });
    this.onProviderTransfer$.next(transferData);
  }
  emitChatStart() {
    if (!this.transferInProgress) {
      this.onChatStart$.next(new Date());
    } else {
      this.transferInProgress = false;
    }
  }
  emitChatEnd(origin) {
    this.onChatEnd$.next({
      origin,
      timestamp: new Date(),
    });
  }
  getCurrentChatState() {
    return this.currentState;
  }
  getCurrentMessageId() {
    return this.currentMsgId;
  }
  incrementMessageId() {
    this.currentMsgId++;
  }
  addToSentMessages(data) {
    this.sentMessages.push({
      data,
      ackInfo: 'NOT DELIVERED',
      resent: false,
    });
  }
  getTransferInProgress() {
    return this.transferInProgress;
  }
  transferCanceled() {
    this.transferInProgress = false;
  }
  getSentMessages() {
    return this.sentMessages;
  }
  getProviderTransferEvent() {
    return this.onProviderTransfer$.asObservable();
  }
}
//# sourceMappingURL=chat-instance.js.map
